import { forwardRef } from 'react';
import { AnimatedLoadingText } from './animated-loading-text';
import { MotionDoorLogo } from './motion-door-logo';
import { PageLoading } from '../page-loading/page-loading';
import type { EnterBrandPageLoadingProps } from './types';

function renderAnimatedLoadingText(text: string) {
    return <AnimatedLoadingText text={text} />;
}

/** Enter 应用统一使用的品牌页面级 Loading。 */
export const EnterBrandPageLoading = forwardRef<HTMLDivElement, EnterBrandPageLoadingProps>(
    ({ iconSize = 64, indicator, renderText = renderAnimatedLoadingText, ...props }, ref) => (
        <PageLoading
            {...props}
            ref={ref}
            iconSize={iconSize}
            indicator={indicator ?? <MotionDoorLogo size={iconSize} />}
            renderText={renderText}
        />
    )
);

EnterBrandPageLoading.displayName = 'EnterBrandPageLoading';
